import React, { useEffect, useState } from "react";
import clsx from "clsx";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";

import s from "./PaginationBtns.less";

interface IPaginations {
  total: number;
  modal?: boolean;
}

const PaginationBtns: React.FC<IPaginations> = ({
  total = 0,
  modal = false,
}) => {
  const { page, count, pageModal, countModal } = useGetLocationData();
  const setData = useSetLocationData();

  const setPage = (i) => {
    setData(modal ? "pageModal" : "page", i);
    window.scrollTo(0, 0);
  };

  const valberis = Math.ceil(
    total / (modal ? +countModal || 10 : +count || 10)
  );
  const [local, setLocal] = useState([]);
  const [initialFirstPage, setInitialFirstPage] = useState(0);

  useEffect(() => {
    const currrentLocal = [];

    if (initialFirstPage + 10 < valberis) {
      for (
        let index = initialFirstPage;
        index < initialFirstPage + 10;
        index++
      ) {
        currrentLocal.push(index);
      }
    } else {
      for (let index = initialFirstPage; index < valberis; index++) {
        currrentLocal.push(index);
      }
    }
    setLocal(currrentLocal);
  }, [total, initialFirstPage, count, countModal]);

  const firstPage = () => {
    setPage(0);
    setInitialFirstPage(0);
    window.scrollTo(0, 0);
  };
  const next10Pages = () => {
    setInitialFirstPage(initialFirstPage - 10);
    setPage(initialFirstPage - 10);
    window.scrollTo(0, 0);
  };
  const prev10Pages = () => {
    setInitialFirstPage(initialFirstPage + 10);
    setPage(initialFirstPage + 10);
    window.scrollTo(0, 0);
  };
  const lastPage = () => {
    setPage(valberis - 1);
    setInitialFirstPage(Math.floor((valberis - 1) / 10) * 10);
    window.scrollTo(0, 0);
  };

  return (
    <div className={s.box}>
      {initialFirstPage > 9 && (
        <>
          <div className={s.btn} onClick={firstPage}>
            {1}
          </div>
          <div className={s.btn} onClick={next10Pages}>
            ...
          </div>
        </>
      )}

      {valberis &&
        local.map((i) => (
          <div
            key={i}
            onClick={() => setPage(i)}
            className={clsx({
              [s.active]: modal ? +pageModal === i : +page === i,
              [s.btn]: true,
            })}
          >
            {i + 1}
          </div>
        ))}

      {initialFirstPage + 10 < valberis && (
        <>
          <div className={s.btn} onClick={prev10Pages}>
            ...
          </div>
          <div className={s.btn} onClick={lastPage}>
            {valberis}
          </div>
        </>
      )}
    </div>
  );
};
export default PaginationBtns;
